import LockIcon from '@mui/icons-material/Lock'
import { Box, Tooltip } from '@mui/material'
import { useTranslate } from 'ra-core'
import { EditButton, useResourceContext } from 'react-admin'

const LockedForUpdateIcon = () => {
  const resource = useResourceContext()
  const translate = useTranslate()

  return (
    <Tooltip title={translate(`resources.${resource}.forms.helperTexts.locked_for_update`)}>
      <Box>
        <EditButton icon={<LockIcon />} disabled={true} />
      </Box>
    </Tooltip>
  )
}

export default LockedForUpdateIcon
